import { render, staticRenderFns } from "./ThemeSetting.vue?vue&type=template&id=e1cdf344&"
import script from "./ThemeSetting.vue?vue&type=script&lang=js&"
export * from "./ThemeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports